import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaUser, FaLock } from 'react-icons/fa';
import './login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    // Hardcoded credentials check
    if (username === 'admin' && password === 'admin') {
      sessionStorage.setItem('isLoggedIn', 'true');
      navigate('/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="custom-login-container">
      <form className="custom-login-form" onSubmit={handleLogin}>
        <h2 className="custom-login-title">Login</h2>

        {error && <p className="custom-login-error">{error}</p>}

        <div className="custom-login-input-group">
          <label htmlFor="username" className="custom-login-label">
            <FaUser className="custom-login-icon" /> Username
          </label>
          <input
            type="text"
            id="username"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="custom-login-input"
            required
          />
        </div>

        <div className="custom-login-input-group">
          <label htmlFor="password" className="custom-login-label">
            <FaLock className="custom-login-icon" /> Password
          </label>
          <div className="custom-password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="custom-login-input"
              required
            />
            <button
              type="button"
              className="custom-eye-button"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        <button type="submit" className="custom-login-button">Log In</button>
      </form>
    </div>
  );
};

export default Login;